import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTypesDay = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10846_87587)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12.1553 13.1384C8.48471 13.1384 5.4502 16.057 5.4502 19.6678C5.4502 21.4874 6.11489 23.1767 7.21104 24.6084C8.40908 26.1878 9.89848 27.5639 11.5845 28.644C12.0056 28.9125 12.3519 28.8936 12.7356 28.644C14.412 27.5639 15.9014 26.1878 17.1098 24.6084C18.2052 23.1767 18.8707 21.4874 18.8707 19.6678C18.8707 16.057 15.8362 13.1384 12.1553 13.1384Z",
				fill: "#52C75F"
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .5,
				filter: "url(#filter0_f_10846_87587)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M12.1717 16.8037C10.1858 16.8037 8.54395 18.3607 8.54395 20.287C8.54395 21.2577 8.90358 22.1589 9.49665 22.9227C10.1449 23.7653 10.9507 24.4994 11.8629 25.0756C12.0908 25.2188 12.2781 25.2087 12.4857 25.0756C13.3928 24.4994 14.1986 23.7653 14.8524 22.9227C15.445 22.1589 15.8051 21.2577 15.8051 20.287C15.8051 18.3607 14.1633 16.8037 12.1717 16.8037Z",
					fill: "#004FFF"
				})
			}),
			/* @__PURE__ */ _jsx("foreignObject", {
				x: -13.6118,
				y: -17.7932,
				width: 68.1616,
				height: 71.5864,
				children: /* @__PURE__ */ _jsx("div", {
					xmlns: "http://www.w3.org/1999/xhtml",
					style: {
						backdropFilter: "blur(12px)",
						clipPath: "url(#bgblur_1_10846_87587_clip_path)",
						height: "100%",
						width: "100%"
					}
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-figma-bg-blur-radius": 24,
				d: "M20.4613 6.20679C14.947 6.20679 10.3882 10.5914 10.3882 16.016C10.3882 18.7496 11.3868 21.2874 13.0335 23.4384C14.8334 25.8112 17.0709 27.8784 19.6039 29.5011C20.2365 29.9044 20.7567 29.8761 21.3332 29.5011C23.8517 27.8784 26.0893 25.8112 27.9047 23.4384C29.5502 21.2874 30.55 18.7496 30.55 16.016C30.55 10.5914 25.9912 6.20679 20.4613 6.20679Z",
				fill: "#51C75E",
				fillOpacity: .35
			}),
			/* @__PURE__ */ _jsx("foreignObject", {
				x: 2.06836,
				y: -1.9812,
				width: 36.6553,
				height: 36.5483,
				children: /* @__PURE__ */ _jsx("div", {
					xmlns: "http://www.w3.org/1999/xhtml",
					style: {
						backdropFilter: "blur(7.5px)",
						clipPath: "url(#bgblur_2_10846_87587_clip_path)",
						height: "100%",
						width: "100%"
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter2_d_10846_87587)",
				"data-figma-bg-blur-radius": 15,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M20.3882 19.5673C18.5597 19.5673 17.0684 18.1381 17.0684 16.3208C17.0684 14.5177 18.5597 13.0188 20.3882 13.0188C22.2179 13.0188 23.7236 14.5177 23.7236 16.3208C23.7236 18.1381 22.2179 19.5673 20.3882 19.5673Z",
					fill: "white"
				})
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_f_10846_87587",
			x: -7.45605,
			y: .803711,
			width: 39.2612,
			height: 40.3755,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 8,
					result: "effect1_foregroundBlur_10846_87587"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "bgblur_1_10846_87587_clip_path",
			transform: "translate(13.6118 17.7932)",
			children: /* @__PURE__ */ _jsx("path", { d: "M20.4613 6.20679C14.947 6.20679 10.3882 10.5914 10.3882 16.016C10.3882 18.7496 11.3868 21.2874 13.0335 23.4384C14.8334 25.8112 17.0709 27.8784 19.6039 29.5011C20.2365 29.9044 20.7567 29.8761 21.3332 29.5011C23.8517 27.8784 26.0893 25.8112 27.9047 23.4384C29.5502 21.2874 30.55 18.7496 30.55 16.016C30.55 10.5914 25.9912 6.20679 20.4613 6.20679Z" })
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter2_d_10846_87587",
			x: 2.06836,
			y: -1.9812,
			width: 36.6553,
			height: 36.5483,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 5,
					dy: 5
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.15375 0 0 0 0 0.522433 0 0 0 0 0.9 0 0 0 0.5 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_10846_87587"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_10846_87587",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "bgblur_2_10846_87587_clip_path",
			transform: "translate(-2.06836 1.9812)",
			children: /* @__PURE__ */ _jsx("path", { d: "M20.3882 19.5673C18.5597 19.5673 17.0684 18.1381 17.0684 16.3208C17.0684 14.5177 18.5597 13.0188 20.3882 13.0188C22.2179 13.0188 23.7236 14.5177 23.7236 16.3208C23.7236 18.1381 22.2179 19.5673 20.3882 19.5673Z" })
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_10846_87587",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 36,
				height: 36,
				fill: "white"
			})
		})
	] })]
});
export default SvgTypesDay;
